import { formatter } from '@uhg-abyss/web/tools/formatter';

export const formatMoney = (money, defaultValue) => {
  if (defaultValue && !money) {
    return defaultValue;
  }
  return formatter('money', money);
};
